module.exports = __webpack_public_path__ + "img/home-7.0d7ac737.png";